// extracted by mini-css-extract-plugin
export default {"modal":"CommonModal_modal__vd6ts","bow":"CommonModal_bow__Zud-S","title":"CommonModal_title__72oUL"};